module.exports = __webpack_public_path__ + "fonts/FSSinclair-LightItalic.a3f1ffa7.otf";